import { forwardRef } from "react";
import type { InputHTMLAttributes, TextareaHTMLAttributes, SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

const BASE =
  "w-full rounded-xl border border-ink-500 bg-ink-750 px-4 text-sm text-haze-100 " +
  "placeholder:text-haze-400/70 transition-colors " +
  "hover:border-ink-500 focus:border-accent/60 focus:outline-none focus:ring-1 focus:ring-accent/40 " +
  "disabled:opacity-50 disabled:cursor-not-allowed";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cn(BASE, "h-11", className)} {...rest} />;
  },
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, rows = 4, ...rest }, ref) {
    return <textarea ref={ref} rows={rows} className={cn(BASE, "py-2.5 resize-y leading-relaxed", className)} {...rest} />;
  },
);

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...rest }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          BASE,
        "h-11 appearance-none bg-no-repeat pr-10 cursor-pointer",
          "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2212%22 height=%228%22 fill=%22none%22%3E%3Cpath d=%22M1 1l5 5 5-5%22 stroke=%22%238b949e%22 stroke-width=%221.5%22 stroke-linecap=%22round%22/%3E%3C/svg%3E')]",
          "bg-[right_0.75rem_center]",
          className,
        )}
        {...rest}
      >
        {children}
      </select>
    );
  },
);
